import { Injectable } from '@angular/core';
import { environment } from '../environments/environment';
import { ApiService } from '../shared/services/api.service';
import { LocationService } from '../shared/services/location.service';
import { UserDto } from './user.dto';

@Injectable({
  providedIn: 'root',
})
export class AuthService {
  private user?: UserDto;

  constructor(
    private readonly location: LocationService,
    private readonly api: ApiService,
  ) {}

  public async logout(): Promise<void> {
    await this.api.get<any>(environment.api.auth + `/logout`);
    this.user = undefined;
    this.location.go('/login');
  }

  public isInGroups(groups: string[]): boolean {
    return this.user?.groups?.some((group: string) => groups?.includes(group));
  }

  public async sngSignIn(): Promise<void> {
    this.location.go(environment.api.auth + '/external');
  }

  public async pcSignIn(): Promise<void> {
    this.location.go(environment.api.auth + '/pc');
  }

  async getUser(): Promise<UserDto | undefined> {
    if (!this.user) {
      try {
        this.user = await this.loadUserData();
      } catch (error) {
        this.user = undefined;
      }
    }
    return this.user;
  }

  private loadUserData(): Promise<UserDto | undefined> {
    return this.api.get<UserDto>(environment.api.auth + `/user`);
  }
}
